export default "__VITE_ASSET__DxjZnJX1__"